<template>
  <el-dialog title="回答库" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <div v-for="(item,index) in form" :key="index" class="mt10"><el-tag >{{index+1}}、{{item.content}}</el-tag></div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="formVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import custServiceInfoLibraryContent from '@/api/customer/custServiceInfoLibraryContent'

export default {
  data() {
    return {
      form: [],
      formVisible: false,
    }
  },
  created() {

  },
  methods: {
    handleShow(row) {
      custServiceInfoLibraryContent.fetchList({ infoLibraryId: row.id }).then((res) => {
        this.form = res.data
        this.formVisible = true
      })
    },
  }
}
</script>
